(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-dino-alternative"] && !window.DesignMode) return;
  try {
    
  class HiDinoAlternative extends HTMLElement {
    constructor() {
      super();
      this.whyDinoLink = this.querySelector('.hi-dino-alternative__why-dino');
      this.columnsContainer = this.querySelector('.hi-dino-alternative__columns');
      
      if (this.whyDinoLink && this.columnsContainer) {
        this.whyDinoLink.addEventListener('click', this.handleWhyDinoClick.bind(this));
      }
    }

    handleWhyDinoClick(event) {
      event.preventDefault();
      const firstColumn = this.columnsContainer.querySelector('.hi-dino-alternative__column');
      if (firstColumn) {
        const scrollAmount = firstColumn.offsetWidth + 16; // column width + gap
        this.columnsContainer.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    }
  }

  customElements.define('hi-dino-alternative', HiDinoAlternative);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hi-dino-smarter"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.hi-dino-smarter__tab-button');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const content = button.querySelector('.hi-dino-smarter__tab-content');
      
      // Close all other tabs
      tabButtons.forEach(otherButton => {
        if (otherButton !== button) {
          otherButton.setAttribute('aria-expanded', 'false');
          const otherContent = otherButton.querySelector('.hi-dino-smarter__tab-content');
          otherContent.hidden = true;
        }
      });
      
      // Toggle current tab
      button.setAttribute('aria-expanded', !isExpanded);
      content.hidden = isExpanded;

      // If expanding, ensure the tab is fully visible
      if (!isExpanded) {
        setTimeout(() => {
          const buttonRect = button.getBoundingClientRect();
          const containerRect = button.closest('.hi-dino-smarter__tabs').getBoundingClientRect();
          
          if (buttonRect.bottom > containerRect.bottom) {
            const scrollOffset = buttonRect.bottom - containerRect.bottom + 24; // Add padding
            button.closest('.hi-dino-smarter__tabs').scrollTop += scrollOffset;
          }
        }, 10);
      }
    });
  });

  // Smooth scroll effect
  const tabsContainers = document.querySelectorAll('.hi-dino-smarter__tabs');
  
  tabsContainers.forEach(container => {
    let isMouseOver = false;
    let targetScrollY = 0;
    let currentScrollY = 0;
    const scrollSpeed = 0.15; // Slightly increased for better coverage
    const smoothness = 0.1;

    container.addEventListener('mousemove', (e) => {
      if (!isMouseOver) return;
      
      const rect = container.getBoundingClientRect();
      const mousePercentY = (e.clientY - rect.top) / rect.height;
      
      // Calculate target scroll position based on mouse position
      const maxScroll = container.scrollHeight - container.clientHeight;
      targetScrollY = maxScroll * (mousePercentY * 1.1 - 0.05);
    });

    container.addEventListener('mouseenter', () => {
      isMouseOver = true;
      currentScrollY = container.scrollTop;
    });

    container.addEventListener('mouseleave', () => {
      isMouseOver = false;
    });

    // Smooth animation loop
    function animate() {
      if (isMouseOver) {
        // Smooth interpolation between current and target scroll position
        currentScrollY += (targetScrollY - currentScrollY) * smoothness;
        container.scrollTop = currentScrollY;
      }
      requestAnimationFrame(animate);
    }

    animate();

    // Touch device handling
    let touchStartY = 0;
    let lastTouchY = 0;
    let momentum = 0;
    const momentumFriction = 0.95;

    container.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
      lastTouchY = touchStartY;
      momentum = 0;
      isMouseOver = false;
    });

    container.addEventListener('touchmove', (e) => {
      const touchY = e.touches[0].clientY;
      const deltaY = lastTouchY - touchY;
      container.scrollTop += deltaY;
      
      // Calculate momentum
      momentum = deltaY;
      lastTouchY = touchY;
      
      e.preventDefault();
    });

    container.addEventListener('touchend', () => {
      // Apply momentum scrolling
      function momentumScroll() {
        if (Math.abs(momentum) > 0.1) {
          container.scrollTop += momentum;
          momentum *= momentumFriction;
          requestAnimationFrame(momentumScroll);
        }
      }
      momentumScroll();
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
